import { Card, CardBody, Col } from "reactstrap";
import { Badges } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BadgesType } from "../../../../Types/CommonComponentsType";

const CommonBadges:React.FC<BadgesType> = ({ title, span, data, roundedPills, number, className, icon }) => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={title} span={span} />
        <CardBody>
          <div className="badge-spacing">
            {data.map((item) => (
              <Badges pill={roundedPills} color={item.color} key={item.id} className={className}>
                {number ? item.id : item.text}
                {icon && item.iconName}
              </Badges>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CommonBadges;
